(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    

	$('[data-behavior=accordion]').simpleAccordion({});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-collection-template"]) return;
  try {
    

<!-- Load more Button -->

$(document).ready(function () {
	attachClickEvent();
});

  var pInfScrLoading = false;
  var pInfScrDelay = 250;
  function pInfScrExecute() {
    pInfScrNode = $('.load-more').last();	
    pInfScrURL = $('.load-more a').last().attr("href");

      if(pInfScrNode.length > 0 && pInfScrNode.css('display') != 'none') {
        $.ajax({
        type: 'GET',
        url: pInfScrURL,
        beforeSend: function() {
        pInfScrLoading = true;
        pInfScrNode.clone().empty().insertAfter(pInfScrNode).append('<img src="https://cdn.shopify.com/s/files/1/0068/2162/assets/loading.gif?105791" />');
        pInfScrNode.hide();
        },
        success: function(data) {
        // remove loading feedback
        pInfScrNode.next().remove();
        pInfScrNode.remove();
        var filteredData = $(data).find(".collection-matrix");
        filteredData.insertBefore( $("#product-list-foot") );					
        pInfScrLoading = false;
        /*$('li.singleproduct').setAllToMaxHeight();*/
        attachClickEvent();
        },
        dataType: "html"
        });
      }
	}

    function attachClickEvent(){
      $('.load-more a').click(function(event){
        pInfScrExecute();
        event.stopPropagation();
        return false;
      });
    }

<!-- /Load more products for downside button -->


<!-- js for sidebar -->

$('.sidebar-content > .title').on("click", function (e) {
  $(this).next('.inner-content').slideToggle(600);
  $(this).toggleClass('open');
  e.stopPropagation();
  e.preventDefault();
});

<!-- /js for sidebar -->


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-list-collection-template"]) return;
  try {
    

<!-- Load more Button -->

$(document).ready(function () {
	attachClickEvent();
});

  var pInfScrLoading = false;
  var pInfScrDelay = 250;
  function pInfScrExecute() {
    pInfScrNode = $('.load-more').last();	
    pInfScrURL = $('.load-more a').last().attr("href");

      if(pInfScrNode.length > 0 && pInfScrNode.css('display') != 'none') {
        $.ajax({
        type: 'GET',
        url: pInfScrURL,
        beforeSend: function() {
        pInfScrLoading = true;
        pInfScrNode.clone().empty().insertAfter(pInfScrNode).append('<img src="https://cdn.shopify.com/s/files/1/0068/2162/assets/loading.gif?105791" />');
        pInfScrNode.hide();
        },
        success: function(data) {
        // remove loading feedback
        pInfScrNode.next().remove();
        pInfScrNode.remove();
        var filteredData = $(data).find(".collection-matrix");
        filteredData.insertBefore( $("#product-list-foot") );					
        pInfScrLoading = false;
        /*$('li.singleproduct').setAllToMaxHeight();*/
        attachClickEvent();
        },
        dataType: "html"
        });
      }
	}

    function attachClickEvent(){
      $('.load-more a').click(function(event){
        pInfScrExecute();
        event.stopPropagation();
        return false;
      });
    }

<!-- /Load more products for downside button -->



<!-- js for sidebar: for view -->

  $('.sidebar-content > .title').on("click", function (e) {
    $(this).next('.inner-content').slideToggle(600);
    $(this).toggleClass('open');
    e.stopPropagation();
    e.preventDefault();
  });

<!-- /js for sidebar -->


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
$('.main-slider').slick({
        autoplay: true,
        arrows: true,		
        dots: true,
		autoplaySpeed: 5000
    });

  } catch(e) { console.error(e); }
})();
})();
